import { render, staticRenderFns } from "./ObjectReplacement.vue?vue&type=template&id=21a5c50b&scoped=true"
import script from "./ObjectReplacement.vue?vue&type=script&lang=js"
export * from "./ObjectReplacement.vue?vue&type=script&lang=js"
import style0 from "./ObjectReplacement.vue?vue&type=style&index=0&id=21a5c50b&prod&scoped=true&lang=css"
import style1 from "./ObjectReplacement.vue?vue&type=style&index=1&id=21a5c50b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a5c50b",
  null
  
)

export default component.exports